import { ErrorType, RequestError } from "./AuthService";
import AlertService from "./libs/AlertService";

const alertError = function (error: RequestError, handler: any = {}): void {
  switch (error.type) {
    case ErrorType.Canceled:
      console.warn(error.message, error.error);
      if (handler.canceled) handler.canceled();
      break;

    case ErrorType.Unautorized:
      console.error(error.message, error.error);

      if (handler.unautorized) handler.unautorized();
      // show error to user
      else
        AlertService.error(
          "Authentifizierungsfehler aufgetreten!",
          "Das Ticket scheint abgelaufen zu sein.",
          "Bitte versuchen Sie sich erneut anzumelden!",
          "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
          "Fehlermeldung: " + error.message,
        );
      break;

    case ErrorType.WrongInput:
      console.debug(error.message, error.error);
      AlertService.info(error.message);
      if (handler.wronginput) handler.wronginput();
      break;

    case ErrorType.Default:
      console.error(error.message, error.error);

      if (handler.default) handler.default();
      // show error message
      else
        AlertService.error(
          "Unerwarteter Fehler!",
          "Überprüfen Sie ihre Internetverbindung und versuchen Sie es in bitte erneut!",
          "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
          "Fehlermeldung: " + error.message,
        );
      break;
  }
};

export { alertError };
